import { Component, h, Prop } from '@stencil/core';

/**
 * This component is used to display an image, and can be hidden at different view sizes.
 */
@Component({
  tag: 'fccd-image',
  styleUrl: 'fccd-image.scss',
})
export class Image {
  /**
   * This location of the image
   */
  @Prop()
  src: string;

  /**
   * The CSS width of the image.
   */
  @Prop()
  width: string;

  /**
   * The CSS height of the image.
   */
  @Prop()
  height: string;

  /**
   * The CSS margin-bottom of the image.
   */
  @Prop()
  marginBottom: string;

  /**
   * If true the image is visible at large view.
   */
  @Prop()
  visibleLg: boolean = true;

  /**
   * If true the image is visible at medium view.
   */
  @Prop()
  visibleMd: boolean = true;

  /**
   * If true the image is visible at small view.
   */
  @Prop()
  visibleSm: boolean = true;

  /**
   * If true the image is visible at extra small view.
   */
  @Prop()
  visibleXs: boolean = true;

  /**
   * The alternate text for the image.
   */
  @Prop()
  alt: string = '';

  private createClassString() {
    const imgClasses = [];
    imgClasses.push(this.sizeClass(this.visibleLg, 'lg'));
    imgClasses.push(this.sizeClass(this.visibleMd, 'md'));
    imgClasses.push(this.sizeClass(this.visibleSm, 'sm'));
    imgClasses.push(this.sizeClass(this.visibleXs, 'xs'));
    return imgClasses.join(' ');
  }

  private sizeClass(visible: boolean, suffix: string): string {
    let classPrefix = 'img-hide-';
    if (visible) {
      classPrefix = 'img-show-';
    }
    return classPrefix + suffix;
  }

  render() {
    const { width, height, marginBottom } = this;
    return <img src={this.src} style={{ width, height, marginBottom }} alt={this.alt} class={this.createClassString()} loading="lazy" />;
  }
}
